<template>
  <div class="container no-padding-container text-gray-600">
    <div class="px-5">
      <div class="pt-5 md:pt-12">
        <h1 class="ota-title mb-3 text-center md:mb-10" v-html="$t('AboutUs.Content.Title')" />
        <p class="ota-body-light" v-html="$t('AboutUs.Content.Description')" />
      </div>
      <div class="lg:flex pt-12">
        <p class="ota-subtitle pb-12 pr-10 lg:pt-4" v-html="$t('AboutUs.General.Subjects')" />
        <div class="mb-10 flex-1 flex justify-end">
          <div class="right-flex w-full">
            <ProductAccordion
              v-for="(contentBlock, index) in content"
              :key="`${contentBlock.Question}-${index}`"
              class="mt-5 border-b"
            >
              <template v-slot:trigger>
                <span v-html="contentBlock.Question" />
              </template>
              <template v-slot:content>
                <div class="ota-small-light pb-5 md:pb-10" v-html="contentBlock.Answer" />
              </template>
            </ProductAccordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductAccordion from '@/components/Webshop/ProductAccordion'

export default {
  name: 'AboutUs',
  layout: 'homepage',
  components: { ProductAccordion },
  computed: {
    content () {
      return this.$t('AboutUs.Content.Questions')
    }
  },
  head () {
    return {
      title: this.$t('AboutUs.PageTitle'),
      meta: [
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: this.$t('AboutUs.Description')
        }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped>
.product-accordion {
  >>> b {
    @apply font-extrabold;
  }

  >>> .ota-p18 {
    font-size: 1.5rem;
  }
}

.right-flex {
  max-width: 75rem;
}
</style>
